// noinspection SpellCheckingInspection

const appName = "REVOO";

export const en = {
  ActivityStatistics: {
    title: "Customer Activities",
    columns: {
      customer: "Customer",
      workouts: "Workouts completed",
      last: "Last completed",
    },
  },
  AssignedPlans: {
    name: "Name",
    assigned_list_sort_end_asc: "Due date (ascending)",
    assigned_list_sort_end_desc: "Due date (descending)",
    assigned_list_sort_name_asc: "Name (A to Z)",
    assigned_list_sort_name_desc: "Name (Z to A)",
    assigned_list_sort_menu_aria:
      "Choose how assigned training plans are ordered",
    cards: "Cards",
    duration: "Duration",
    last_satisfaction: "Last Workout Feedback",
    level: "Level",
    deleteModal: {
      title_one: "Do you want to delete the selected assignment?",
      title_other: "Do you want to delete the selected assignments?",
      subtitle_one:
        "By proceeding you will <strong>delete</strong> the assignment from the list.",
      subtitle_other:
        "By proceeding you will <strong>delete</strong> the selected assignments.",
    },
  },
  AssignedNutritionPlans: {
    name: "Plan",
    days: "Days",
    duration: "Duration",
    energy: "Energy",
    weekly_average: "Weekly average",
    customer_ids: "Customer ID(s)",
    group_ids: "Group ID(s)",
    not_assigned: "Not assigned",
    label_selected: "Selected",
    list: "Assigned nutrition plans",
    empty: "No assigned nutrition plans",
  },
  Calendar: {
    addEvent: "Add event",
    add_email: "Add email",
    add_event: "Add event",
    add_participants: "Add participants",
    agenda: "Agenda",
    appointment: "Appointment",
    calendar: "Calendar",
    create_error_subtitle: "Event not created",
    create_error_title: "Event creation error",
    create_success_subtitle: "Event created successfully",
    create_success_title: "Event created",
    day: "Day",
    delete_appointment: "Delete appointment",
    delete_event_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> the following event from the list.",
    delete_event_title: "Do you want to delete this event?",
    edit_error_subtitle: "Event not edited",
    edit_error_title: "Event editing error",
    edit_event: "Edit event",
    edit_success_subtitle: "Event edited successfully",
    edit_success_title: "Event edited",
    end: "End",
    end_hour: "End hour",
    error_subtitle: "Event list not loaded",
    error_title: "Event error",
    event: "Event",
    event_date: "Event date",
    event_delete: "Delete event",
    event_edit: "Edit event",
    event_notes: "Event notes",
    event_title: "Event title",
    in_person: "In person",
    link_videocall: "Videocall link",
    location: "Location",
    month: "Month",
    new_event: "New event",
    notify_before: "Notify before",
    notify_participants: "Notify participants",
    other_one: "Other event",
    other_other: "+ Other {{count}}",
    participants: "Participants",
    phone_call: "Phone call",
    reminder: "Reminder",
    start: "Start",
    start_hour: "Start hour",
    success_create_event_subtitle: "Event created successfully",
    success_delete_event_subtitle: "Event deleted successfully",
    success_edit_event_subtitle: "Event edited successfully",
    today: "Today",
    update_status_customer: "Update customer status",
    update_status_customer_success: "Customer status updated successfully",
    videocall: "Videocall",
    week: "Week",
  },
  Check: {
    empty: "Incomplete data",
    unit: {
      years: " years",
      degrees: "°",
      kilograms: "kg",
      grams: "g",
      centimeters: "cm",
      millimeters: "mm",
      meters: "m",
      percentage: "%",
      calories: "kcal",
      age: " age",
    },
    filters: {
      date: "Status as of",
      all: "Latest entries",
    },
    protocol: {
      "3_female": "3 Skinfolds - Woman",
      "3_male": "3 Skinfolds - Man",
      "7_male": "7 Skinfolds - Man",
      "7_female": "7 Skinfolds - Woman",
    },
    measurementSection: "Body measurements",
    compositionSection: "Mass Composition",
    labels: {
      muscle: "Muscular",
      fat: "Fat",
      bone: "Bone",
    },
    compositions: {
      modalUser: "Customer: {{name}} {{surname}}",
      title: "Composition",
      edit: "Edit",
      isEmpty: "No composition present",
      data: "Data",
    },
    compositionsStore: {
      new: "New composition",
      edit: "Edit composition",
      delete: "Delete",
      error: "Composition error",
      errorDelete: "Error deleting composition",
      success: "Composition saved successfully",
      successDelete: "Composition deleted successfully",
      date: "Composition date",
      overrideDateMessage:
        "There are already compositions on this date, do you want to overwrite them?",
    },
    measurements: {
      modalUser: "Customer: {{name}} {{surname}}",
      title: "Measurements",
      dx: "RH",
      sx: "LH",
      edit: "Edit",
      isEmpty: "No measurements present",
      data: "Data",
    },
    measurementsStore: {
      new: "New measurements",
      edit: "Edit measurements",
      delete: "Delete",
      error: "Error in measurements",
      errorDelete: "Error deleting measurements",
      success: "Measurements saved successfully",
      successDelete: "Measurements deleted successfully",
      date: "Measurement date",
      overrideDateMessage:
        "There are already measurements on this date, do you want to overwrite them?",
    },
    health: {
      modalUser: "Customer: {{name}} {{surname}}",
      title: "Monitoring health data",
      average: "Average",
      edit: "Modify",
      results: "Result",
      isEmpty: "No synch data present",
      body_fat: {
        "7_female": "Body Fat (JP-7/woman)",
        "3_female": "Body Fat (JP-3/woman)",
        "3_male": "Body Fat (JP-3/man) ",
        "7_male": "Body Fat (JP-7/man)",
      },
    },
    plicometries: {
      modalUser: "Customer: {{name}} {{surname}}",
      title: "Skinfolds",
      average: "Average",
      edit: "Edit",
      results: "Result",
      isEmpty: "No skinfold measurements present",
      body_fat: {
        "7_female": "Body Fat (JP-7/woman)",
        "3_female": "Body Fat (JP-3/woman)",
        "3_male": "Body Fat (JP-3/man)",
        "7_male": "Body Fat (JP-7/man)",
      },
    },
    plicometriesStore: {
      new: "New skinfold measurement",
      edit: "Edit skinfold measurement",
      delete: "Delete",
      error: "Skinfold measurement error",
      errorDelete: "Error deleting skinfold measurement",
      success: "Skinfold measurement saved successfully",
      successDelete: "Skinfold measurement deleted successfully",
      date: "Skinfold measurement date",
      overrideDateMessage:
        "There are already skinfold measurements on this date, do you want to overwrite them?",
    },
    modalDetails: {
      lastMeasurement: "Last measurement",
      deviation: "Deviation",
      history: "History",
      seeAll: "See all",
      summary: "Summary",
      date: "Date",
      value: "Value",
      filters: {
        last12months: "Last 12 months",
        last6months: "Last 6 months",
        last3months: "Last 3 months",
        lastMonth: "Last month",
        all: "All",
      },
      graphEmpty: "No data to show",
      historyEmpty: "No data to show",
    },
    PhotoProgress: {
      isEmpty: "No photos present",
      photo: "Photo",
      gallery: "Photo gallery",
      form: {
        date: "Select measurement date*",
        front_view: "Front",
        rear_view: "Back",
        right_view: "Right Side",
        left_view: "Left Side",
      },
      delete: {
        modal: {
          title: "Do you want to delete <br />the selected photos?",
          description:
            "By proceeding you will <strong>lose them</strong> permanently",
        },
        successMessage: {
          title: "Photos deleted successfully",
        },
        errorMessage: {
          title: "Error deleting photos",
        },
      },
      create: {
        modal: {
          title: "Progress photos",
          modalUser: "Customer: {{name}} {{surname}}",
        },
        successMessage: {
          title: "Photos uploaded successfully",
        },
        errorMessage: {
          title: "Error uploading photos",
        },
      },
      compare: {
        modal: {
          title: "Compare photos",
          modalUser: "Customer: {{name}} {{surname}}",
        },
      },
    },
  },
  Customers: {
    insert_attachment: "Insert attachment",
    start_date: "Start date",
    end_date: "End date",
    athlete_name: "Athlete Name",
    combination: "Combination",
    set: "Set",
    exercise: "Exercise",
    reps: "Reps",
    weight: "Weight",
    tut: "TUT",
    rest: "Rest",
    end: "End",
    notes: "Notes",
    subscriptions_note: "Subscription notes",
    plan_name: "Plan name",
    no_workout_plans: "No workout plans",
    no_subscriptions: "No subscriptions",
    no_notes: "No notes",
    group_members: "Group members",
    add_member_success: "Member added successfully",
    remove_member_success: "Member removed successfully",
    subscriptionsNote: {
      title: "Subscriptions note",
      successEditNote: "Note edited successfully",
    },
    histories: {
      form: {
        allergies: "Allergies",
        asthma: "Asthma",
        blood_group: "Blood group",
        contraceptive_pill: "Contraceptive pill",
        diabetes: "Diabetes",
        diagnosed_pathologies: "Diagnosed pathologies",
        disorders: "Eating disorders",
        drugs: "Drugs",
        fractures: "Fractures",
        goal: "Goal",
        goal_description: "Goal description",
        height: "Height",
        intestinal_irregularity: "Intestinal irregularity",
        intolerance: "Intolerances",
        irregular_periods: "Irregular period",
        job: "Job",
        last_revelation: "Last revelation",
        lifestyle: "Lifestyle",
        mmhg: "Blood pressure",
        other_pathologies: "Other pathologies",
        postural: "Postural problems",
        problems_cardiac: "Cardiac problems",
        problems_thyroid: "Thyroid problems",
        sport: "Physical activity",
        supplements: "Supplements use",
        supply: "Diet",
        surgical: "Surgical interventions",
        weight: "Weight",
        workout_freq: "Workout frequency",
        workout_location: "Workout location",
        workout_location_option: {
          gym: "Gym",
          home_gym: "Home gym",
          at_home_with_minimal_equipment: "At home with minimal equipment",
          outdoors: "Outdoors",
          other: "Other",
        },
        workout_freq_option: {
          one: "1 time a week",
          two: "2 times a week",
          three: "3 times a week",
          four: "4 times a week",
          five: "5 times a week",
          six: "6 times a week",
          seven: "7 times a week",
        },
        goal_option: {
          fat_loss: "Fat loss",
          definition: "Definition",
          muscle_mass: "Muscle mass gain",
          athletic_preparation: "Athletic preparation",
          rehabilitation: "Rehabilitation",
          postural_correction: "Postural correction",
          other: "Other",
        },
        lifestyle_option: {
          lethargic: "Lethargic",
          sedentary: "Sedentary",
          slightly_active: "Slightly active",
          active: "Active",
          very_active: "Very active",
          extremely_active: "Extremely active",
        },
      },
      error: {
        get: {
          title: "Anamnesis error",
          subtitle: "Anamnesis not loaded",
        },
        create: {
          title: "Anamnesis error",
          subtitle: "Anamnesis not created",
        },
        edit: {
          title: "Anamnesis error",
          subtitle: "Anamnesis not modified",
        },
        delete: {
          title: "Anamnesis error",
          subtitle: "Anamnesis not deleted",
        },
      },
      success: {
        create: {
          title: "Anamnesis created",
          subtitle: "Anamnesis created successfully",
        },
        edit: {
          title: "Anamnesis modified",
          subtitle: "Anamnesis modified successfully",
        },
        delete: {
          title: "Anamnesis deleted",
          subtitle: "Anamnesis deleted successfully",
        },
      },
      title: "Anamnesis",
      add_history: "Add anamnesis",
      label_empty_table: "No anamnesis found",
      draft: "(draft)",
      created_at: "Date",
      created_by: "Created by",
      filled_by: "Filled by",
      edit_history: "Edit anamnesis",
      new_history: "New anamnesis",
      duplicate_history: "Duplicate anamnesis",
      view_history: "View anamnesis",
      new: {},
      edit: {},
      delete: {
        title: "Do you want to delete <br />the selected anamnesis?",
        description: "Proceeding <strong>you will lose it</strong> permanently",
      },
    },
    assign_video: "Assign Video",
    error: {
      get_customers_title: "Customers error",
      get_customers_subtitle: "Customer settings not loaded",
    },
    weeks_duration: "Duration in weeks",
    executed_days: "Executed days",
    workouts: "Workouts",
    per_side: "x Side",
    side_left_short: "L",
    side_right_short: "R",
    workout_feedback: "Workout feedback",
    method: {
      time_circuit: "Time circuit",
      normal: "Single",
      emom: "EMOM",
      circuit: "Circuit",
      superset: "Superset",
    },
    email_already_assigned_alert: {
      title: "Email already assigned",
      message:
        "This email is already associated with another PT. Are you sure you want to add the customer? The customer will receive an email to accept the creation of their account.",
      confirm: "Confirm",
      cancel: "Cancel",
    },
    customer_deleted_alert: {
      message:
        "This email is associated with a customer that has been deleted from the system. To proceed, use a different email or modify the customer data.",
      ok: "I understand",
    },
    customer_already_owned_alert: {
      message:
        "This customer is already associated with your account. Check your customer list or use a different email to create a new one.",
      ok: "I understand",
    },
    pending_migration_alert: {
      message:
        "A migration request for this customer is already pending. The request is being processed and you will receive a notification once completed.",
      ok: "I understand",
    },
    sets: "Sets",
    card: "Card",
    card_list: "Card list",
    training_plans: "Training plans",
    executed_workouts: "Executed workouts",
    activate_training_plan: "Active training plan",
    activate_training_plan_success: "Training plan activated successfully",
    deactivate_training_plan: "Deactivate training plan",
    deactivate_training_plan_success: "Training plan deactivated successfully",
    edit_equipment: "Edit equipment",
    edit_equipment_success: "Equipment edited successfully",
    last: "Last",
    active_plan: "Active plan",
    inactive_plan: "Inactive plan",
    group_plan_active_one:
      "Plan of the group «{{groups}}» the customer belongs to. Turn it on or off from the group.",
    group_plan_active_other:
      "Plan of the groups «{{groups}}» the customer belongs to. Turn it on or off from the group.",
    group_plan_inactive_one:
      "Plan of the group «{{groups}}» the customer belongs to. Turned off from the group.",
    group_plan_inactive_other:
      "Plan of the groups «{{groups}}» the customer belongs to. Turned off from the group.",
    activate_plan_to_notify: "Activate the plan to send notifications",
    notification_sent: "Notified",
    notify_training_plan: "Notify training plan",
    notify_training_plan_success:
      "Training plan notification sent successfully",
    send_notification: "Send notification",
    equipment: "Equipment",
    create_training_plan: "Create training plan",
    assigned_training_plans: "Assigned training plans",
    count_workouts_zero: "No workouts performed",
    count_workouts_one: "{{count}} workout",
    count_workouts_other: "{{count}} workouts",
    count_events_zero: "No events",
    count_events_one: "{{count}} event",
    count_events_other: "{{count}} events",
    calendar: "Calendar",
    add_event: "Add event",
    manage_groups: "Manage groups",
    create_subscription: "Create subscription",
    create_subscription_success: "Subscription created successfully",
    payment_date: "Payment date",
    settled_payment: "Payment settled",
    subscription_payment: "Subscription payment",
    draft: "(draft)",
    deactivate_customer_title:
      "Deactivate the customer at the end of the subscription",
    deactivate_customer_subtitle:
      "You cannot perform this operation if the subscription has already expired",
    duration_type_days: "Days",
    duration_type_weeks: "Weeks",
    duration_type_months: "Months",
    duration_type: "Duration type",
    date_of_start: "Start date",
    subscriptions_active: "Active",
    subscriptions_expired: "Expired",
    subscription: "Subscription",
    add_subscription: "Add subscription",
    edit_subscription: "Edit subscription",
    edit_subscription_success: "Subscription edited successfully",
    label_empty_notes_table: "No notes found",
    delete_note: "Delete note",
    delete_note_success: "Note deleted successfully",
    delete_note_title: "Do you want to delete this note?",
    delete_subscription: "Delete subscription",
    delete_training_plan: "Delete training plan",
    delete_training_plan_success: "Training plan deleted successfully",
    delete_training_plan_title: "Do you want to delete this training plan?",
    delete_training_plan_subtitle:
      "Proceeding <strong>you will permanently delete</strong><br /> the following training plan from the list.",
    delete_subscription_title: "Do you want to delete this subscription?",
    delete_subscription_success: "Subscription deleted successfully",
    delete_note_subtitle:
      "Proceeding <strong>you will permanently delete</strong><br /> the following note from the list.",
    delete_subscription_subtitle:
      "Proceeding <strong>you will permanently delete</strong><br /> the following subscription from the list.",
    important: "Important",
    create_note: "Create note",
    create_note_success: "Note created successfully",
    text: "Text",
    title: "Title",
    low: "Low",
    medium: "Medium",
    high: "High",
    priority: "Priority",
    detail_note: "Note detail",
    add_note: "Add note",
    edit_note: "Edit note",
    edit_note_success: "Note edited successfully",
    joined_at: "Joined on {{date}}",
    unpaid: "Unpaid",
    price: "Price",
    start: "Start",
    manage: "Manage",
    subscriptions: "Subscriptions",
    active_subscriptions: "Active subscriptions",
    no_surveys_label: "No surveys",
    no_groups_label: "No groups",
    surveys: "Surveys",
    important_notes: "Important notes",
    add: "Add",
    next_meeting: "Next meeting",
    last_workout: "Last workout",
    see_all: "See all",
    reset_password: "Reset Password",
    active_profile: "Active profile",
    edit_goals: "Edit goals",
    success_edit_goals: "Goals updated successfully",
    goal: "Goal",
    goals: "Goals",
    goals_to_achieve: "Goals to achieve",
    edit: "Edit",
    send_message: "Send message",
    label_empty_assigned_video_list: "No assigned videos",
    label_empty_playlist_list: "No assigned playlists",
    no_expiration: "No expiration",
    expired: "Expired",
    remove_assign_label:
      "Do you want to remove the assignment from this customer?",
    remove_user_from_group:
      "Do you want to remove the customer from the group?",
    missing_days: "Expires in {{count}} days",
    active_from: "Active from",
    weeks: "{{ count }} weeks",
    months: "{{ count }} months",
    days: "{{ count }} days",
    duration: "Duration",
    type: {
      onSiteAndRemote: "On-site and remote",
      onSite: "On-site",
      online: "Online",
      remote: "Remote",
    },
    tabs: {
      summary: "Summary",
      check: "Check",
      media: "Media",
      training_plans: "Workouts",
      nutrition_plans: "Nutrition",
      surveys: "Surveys",
      shared_folder: "Shared Folder",
      mobile_section_caption: "Section",
    },
    goal_type: {
      fat_loss: "Fat Loss",
      mass_gain: "Mass Gain",
      definition: "Definition",
      athletic_training: "Aerobic Training",
      rehabilitation: "Rehabilitation",
      postural_correction: "Postural Gymnastics",
      other: "Other",
    },
    export_training_plan: "Export training plan",
    export_training_plan_success: "Training plan exported successfully",
    export_training_plan_loading: "Exporting",
    video_list: "Assigned video list",
    playlists_list: "Assigned playlists list",
    training_deadline: "Training deadline",
    list: "Customer list",
    add_assignment: "Add Assignment",
    remove_assignment: "Remove Assignment",
    edit_assignment: "Edit Assignment",
    add_assignment_success: "Assignment created successfully",
    remove_assignment_success: "Assignment removed successfully",
    edit_assignment_success: "Assignment edited successfully",
    add_customer: "Add customer",
    error_customers: "Customers error",
    error_customers_subtitle: "Customer list not loaded",
    error_customer_subtitle: "New customer not created",
    email_unavailable:
      "This email address can't be used for a new customer. Use a different one or contact support.",
    error_customer_label: "Customer operation failed",
    error_groups: "Groups error",
    error_groups_subtitle: "Group list not loaded",
    success_customer_subtitle: "New customer created successfully",
    delete_customer_success: "Customer deleted successfully",
    success_reset_password: "Password reset successfully",
    invite: "Invite",
    customer_name: "Customer name",
    update_status_customer: "Update customer status",
    update_status_customer_success: "Customer status updated successfully",
    groups: "Groups",
    group: "Group",
    status: "Status",
    expiry_date: "Training expiration",
    select_range_date: "Select a date range",
    status_active: "Active",
    status_inactive: "Inactive",
    status_no_training: "Never trained",
    status_disabled: "Disabled",
    status_not_very_active: "Not very active",
    total_count: "customers",
    active_count: "active",
    label_selected: "selected",
    no_groups: "No groups",
    new_customer: "New customer",
    edit_customer: "Edit customer",
    edit_customer_success: "Customer edited successfully",
    profile_image: "Profile image",
    choose_image: "Choose image",
    profile_data: "Profile data",
    personal_data: "Personal data",
    delete_customer: "Delete customer",
    delete_customer_title: "Do you want to delete this customer?",
    delete_customer_subtitle:
      "Proceeding you will lose all data, associated workouts.",
    open_link: "Open link",
    shared_folder: "Shared folder",
    shared_folder_url: "Shared folder URL",
    address: "Address",
    fiscal_code: "Tax code",
    contact_data: "Contact data",
    phone: "Phone number",
    prefix: "Prefix",
    other_info: "Other information",
    chat: "Chat",
    customer_type: "Customer type",
    how_did_he_meet_you: "How did he meet you?",
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    gender: "Gender",
    date_of_birth: "Date of birth",
    country: "Country",
    birth_date: "Date of birth",
    copy_email: "Copy email",
    select_all_button_one: `Select the existing customer`,
    select_all_button_other: `Select all {{count}} existing customers`,
    select_all_one: `You have selected {{count}} customer.`,
    select_all_other: `You have selected {{count}} customers.`,
    select_all_total: `All {{count}} customers have been selected`,
    cancel_all: `Cancel selection`,
  },
  Dashboard: {
    error: {
      get_dashboard_title: "Dashboard Error",
      get_dashboard_subtitle: "Dashboard data not loaded",
      update_dashboard_title: "Dashboard Update Error",
      update_dashboard_subtitle: "Dashboard data not updated",
    },
    success: {
      update_dashboard_title: "Dashboard Data Updated",
      update_dashboard_subtitle: "Dashboard data successfully updated",
    },
    hello: "Hello {{name}}",
    referral: {
      title: "Bring a trainer friend to REVOO and save on your subscription.",
      subtitle: "How does it work?",
    },
    note: {
      title: "Notes",
    },
    activities: {
      table: {
        column: {
          customer: "Customer",
          event: "Event",
          created_at: "Date",
        },
        filter: {
          period: "Period",
        },
      },
      period: {
        today: "Today",
        last_week: "Last week",
      },
      title: "Customer Activities",
      summary: {
        title: "Latest customer activities",
        see_all: "See all activities",
        empty: "No customer activity",
      },
      events: {
        new_executed_workout: "Workout plan completion",
        new_executed_workout_with_feedback:
          "Workout plan completion with feedback",
        new_history: "History entry",
        new_measurement: "Measurements entry",
        new_form_submission: "Form submission {{ name }}",
        new_photo_progress: "Progress photo entry",
        new_customer_from_invitation_code: "User registration via invite code",
      },
    },
    deadlines: {
      table: {
        column: {
          instance_type: "Deadline type",
          start: "Term",
          end: "Due date",
        },
        filter: {
          instance_type: "Deadline type",
          period: "Due date",
        },
        days: "{{ count }} days",
        expired: "Expired",
      },
      period: {
        last_two_weeks: "Last 14 days",
        next_two_weeks: "Next 14 days",
        last_week: "Last 7 days",
        next_week: "Next 7 days",
      },
      instance_type: {
        customer_subscriptions: "Subscriptions",
        playlist_assignments: "Playlists",
        training_cards: "Training plans",
        vod_assignments: "Video on demand",
      },
      tabs: {
        expired: "Expired",
        expiring: "Expiring",
      },
      title: "Deadlines",
      summary: {
        title: "Upcoming deadlines",
        see_all: "See deadlines",
      },
      counters: {
        customer_subscriptions: "Subscriptions",
        playlist_assignments: "Playlists",
        training_cards: "Training plans",
        vod_assignments: "Video on demand",
      },
    },
    events: {
      title: "In Calendar",
      subtitle: "Today",
      see_all: "See calendar",
      empty: "No appointments in calendar today",
    },
    messages: {
      title: "New Messages",
      see_all: "See messages",
    },
    tabs: {
      activities: "Activities",
      statistics: "Statistics",
    },
  },
  TagsLibrary: {
    title: "Exercise Types",
    add_tag: "New exercise type",
    edit_tag: "Edit exercise type",
    name: "Name",
    select_all_button_one: `Select the existing exercise type`,
    select_all_button_other: `Select all {{count}} existing exercise types`,
    label_selected: "Selected",
    label_empty_tags_table: "No exercise types found",
    deleteModal: {
      title_one: "Do you want to delete the selected exercise type?",
      title_other: "Do you want to delete the selected exercise types?",
      subtitle_one:
        "By proceeding you will <strong>delete</strong> the exercise type from the list. <br /> and it will no longer appear in created plans and templates.",
      subtitle_other:
        "By proceeding you will <strong>delete</strong> the selected exercise types. <br /> and they will no longer appear in created plans and templates.",
    },
    error: {
      get_tags_title: "Exercise types error",
      get_tags_subtitle: "Exercise types not loaded",
      create_tags_title: "Exercise types error",
      create_tags_subtitle: "Exercise type not created",
      edit_tags: "Exercise types error",
      edit_tags_subtitle: "Exercise type not modified",
      delete_tags_title: "Exercise types error",
      delete_tags_subtitle: "Exercise type not deleted",
    },
    success: {
      success_tags_edit: "Exercise type updated",
      success_tags_edit_subtitle: "Exercise type updated successfully",
      create_tags_title: "Exercise type created",
      create_tags_subtitle: "Exercise type created successfully",
      delete_tags_title: "Exercise type deleted",
      delete_tags_subtitle: "Exercise type deleted successfully",
    },
  },
  ExerciseLibrary: {
    title: "Exercise Library",
    add: "New exercise",
    error: {
      create_exercise: "Create exercise error",
      create_exercise_subtitle: "New exercise not created",
      error_exercises: "Exercises Error",
      error_exercises_subtitle: "Exercise list not loaded",
      delete_exercises: "Delete exercises error",
      delete_exercises_subtitle: "Exercises not deleted",
      get_exercise: "Exercise Error",
      get_exercises_subtitle: "Exercise not loaded",
      edit_exercise: "Edit exercise error",
      edit_exercise_subtitle: "Exercise not modified",
      update_base_exercises_title: "Library Error",
      update_base_exercises_subtitle: "Library not updated",
    },
    success: {
      success_exercise: "Exercise created",
      success_exercise_subtitle: "Exercise created successfully",
      success_exercises: "Exercises created",
      success_exercises_subtitle: "Exercises created successfully",
      delete_exercises: "Delete exercises",
      delete_exercises_subtitle: "Exercises deleted successfully",
    },
    select_all_one: `You selected {{count}} exercise.`,
    select_all_other: `You selected {{count}} exercises.`,
    select_all_total: `All {{count}} exercises have been selected`,
    select_all_button_one: `Select existing exercise`,
    select_all_button_other: `Select all {{count}} existing exercises`,
    cancel_all: `Cancel selection`,
    exercise_name: "Exercise name",
    delete: "Delete",
    label_selected: "selected",
    base: "View REVOO library",
    tags: "Exercise type",
    combine_tags: "Combine",
    combine_tags_hint: "Show only exercises that include all selected tags",
    deleteModal: {
      title_one: "Do you want to delete the selected exercise?",
      title_other: "Do you want to delete the selected exercises?",
      subtitle_one:
        "By proceeding you will <strong>delete</strong> the exercise from the list. <br /> and it will no longer appear in created plans and templates.",
      subtitle_other:
        "By proceeding you will <strong>delete</strong> the selected exercises. <br /> and they will no longer appear in created plans and templates.",
    },
    exerciseStore: {
      add: "New exercise",
      edit: "Edit exercise",
      duplicate: "Duplicate exercise",
      info_message:
        "Your exercises are private. No other Personal Trainer can see them.",
      youtube_warning_existing_title:
        "YouTube videos are no longer supported due to new restrictions on external sharing. Please replace the link to save the changes to this exercise.",
      youtube_warning_new_title:
        "YouTube videos are not currently supported because of new restrictions on external sharing. Please use a link hosted on another platform.",
      external_link_not_supported:
        "Links to external platforms are no longer supported. Remove the link to save changes",
      cloudflare_link_only:
        "Only Cloudflare Stream video links are allowed (e.g. watch.cloudflarestream.com or customer-*.cloudflarestream.com)",
      name: "Exercise name",
      tags: "Exercise type",
      note: "Description",
      link: "Cloudflare video link",
      thumbnail_image: "Cover Photo",
      video: "Video",
      max_size: "Max {{size}}",
    },
  },
  FeatureFlags: {
    accepted: "Accepted",
    not_accepted: "Not accepted",
    submit: "Accept and continue",
    contact: "Have questions? Contact us",
    title: "Updates to our privacy policy",
    description:
      "To continue providing you with optimal service, we have updated our privacy policy which we ask you to read and accept",
    paddle_payment:
      "We have updated our payment system from Stripe to Paddle to offer you a simpler and more efficient management of your subscription.<br><br>" +
      "✅ What changes for you?<br>" +
      "Better management of subscription and invoices<br>" +
      "Greater transparency and data protection<br>" +
      "Invoices issued directly by Paddle, the new payment system <br>" +
      "<br>" +
      "🔹 What does NOT change?<br>" +
      "Your subscription remains active without changes: the price and conditions remain the same. By updating your data, no charges will be made.<br>" +
      "<br>" +
      "🔹 What do you need to do?<br>" +
      "To continue using the service without interruptions, click on the <b>Update payment data</b> button and enter your data.<br><br>" +
      "📌 It only takes a few seconds!",
    data_processor: {
      title: "Your athletes' privacy is important",
      description:
        "To be able to share with you some information that your customers will enter in the REVOO app, the law requires that REVOO appoint you as an external data processor pursuant to Art. 28 of EU Regulation 2016/679. We ask you to review the document below, which you can find in full in your personal area.",
      policy: `**APPOINTMENT AS EXTERNAL DATA PROCESSOR**

*pursuant to **Art. 28 of Regulation (EU) 2016/679*** *concerning the protection of natural persons with regard to the processing of personal data and the free movement of such data and other applicable national and European legislation*

**WHEREAS**

1) **REVOO S.r.l.**, with registered office in Milan (MI), Via Monte Napoleone n. 10, Tax Code and VAT No. 10079510961 (hereinafter "Controller"), represented by its legal representative pro tempore, has entered into a contract with the user duly identified by the email address [EMAIL] (hereinafter "Customer") for the provision of IT services delivered through the web platform and/or mobile application "REVOO" ([https://www.revoo-app.com/](https://www.revoo-app.com/)) (hereinafter, respectively, "Contract" and "Platform");   
2) in the context of using the services under the Contract, the Customer may process - through collection and uploading to the Platform - personal data of third parties (Customer's clients) who use the Platform (hereinafter "Processing" and "Data");  
3) the Controller is the legal entity responsible for processing personal data concerning Platform users;  
4) the Controller's organizational needs require defining the spheres of autonomy and responsibility regarding personal data processing by the Customer;  
5) the Customer, in relation to the processing areas indicated in letters b) and c) above, guarantees to the Controller that they possess the experience, technical expertise, reliability, capabilities and organizational structure suitable to ensure lawful use of the Data and has confirmed sufficient guarantees regarding the implementation of appropriate technical and organizational measures to ensure that the Processing meets the requirements of current legislation and ensures the protection of data subjects' rights;  
6) with this appointment, in accordance with Italian law and current data protection regulations, the Controller intends to appoint the Customer as data processor pursuant to Art. 28 of Reg. (EU) 679/2016 and the Customer expresses their willingness to accept the appointment under data protection legislation.  

Given all of the above, the Controller, as identified,

**APPOINTS**

**the Customer, as identified in the premises, as External Data Processor for the processing carried out through the Platform, for the activities and with reference to the Data referred to in letters b) and c) of the premises** (hereinafter "Processor" and together with the Controller "Parties").

**1. Object and duration of appointment**  
1.1. This appointment establishes the general conditions and rules that must be followed by the Processor regarding Data Processing.  
1.2. The Processor is authorized to organize all Data Processing operations in full compliance with the provisions of Reg. (EU) 2016/679.  
1.3. This appointment is effective from the date of its acceptance by the Processor and will remain in force as long as the Contract is effective between the Parties. Upon termination, for any reason, of the Contract, this appointment shall be considered terminated. It is understood, however, that the Controller may, at any time and without notice, revoke the appointment of the Processor.

**2. Processor's obligations**   
2.1. The Processor has the duty and responsibility to comply with all necessary requirements for compliance with current data protection provisions and to carefully observe what is provided therein, as well as the instructions given from time to time by the Controller regarding Data Processing.   
2.2. The Processor must identify, among their staff, and appoint in writing the persons authorized to process data under the direct authority of the Processor pursuant to data protection legislation provisions, prescribing that they have access only to Data whose knowledge is necessary to fulfill assigned tasks.  
2.3. The Processor undertakes to provide written instructions to persons authorized for Processing regarding Data Processing operations, organizing their activity, supervising compliance with regulations and given instructions.   
2.4. The Processor guarantees Data confidentiality during Processing.  
2.5. The Processor agrees to make available to the Controller, upon written and motivated request, the information necessary to satisfy the Controller's rights of control regarding Data Processing.  
2.6. Where required by law, the Processor must prepare, in writing including electronic format, the register of processing activities to be shown in case of inspection by competent authorities.  
2.7. The Processor undertakes not to use the Data for purposes other than Processing.  
2.8. The Processor guarantees compliance with obligations under Articles 32 to 36 of Reg. (EU) 2016/679 - relating to security, breach notification, impact assessments and consultation with supervisory authorities - taking into account the nature of Processing and information available to the Processor.  
2.9. The Processor undertakes to inform data subjects of the information under Articles 13 and 14 of Reg. (EU) 679/2016.  
2.10. The Processor does not determine the purposes and means of Processing.

**3. Other processors**  
3.1. The Processor, in compliance with conditions under Article 28, paragraphs 2 and 4, of Reg. (EU) 2016/679, undertakes to appoint other processors only with specific written authorization from the Controller and after careful evaluation of experience, technical expertise, reliability, capabilities, organizational structure suitable for processing purposes and methods and for ensuring implementation of technical and organizational measures aimed at safeguarding confidentiality, completeness and integrity of processed data, or otherwise most appropriate to ensure compliance with current data protection legislation provisions. The Processor also undertakes to impose on other processors appointed under this article, through a contract or other binding legal act under current law, the same data protection obligations contained in this appointment deed.

**4. Processor's warranties**  
4.1. The Processor guarantees to the Controller the legitimacy, correctness, formal and substantial regularity, as well as compliance - with provisions in force from time to time regarding protection and processing of personal data - of forms and methods of collection, transfer and making available of Data.  
4.2. For the foregoing, the Processor undertakes to indemnify and hold harmless the Controller from claims, actions, disputes brought by data subjects and/or third parties for any reason for damages arising from violation of obligations under this appointment.

**5. Controller's rights of control**  
The Controller may carry out checks to verify compliance with technical and organizational measures implemented by the Processor.

**6. Data correction, blocking, deletion**  
The Processor may correct, delete or block Processed Data only on indication from the latter. If a data subject should contact the Processor directly with such request, the Processor shall forward the request to the Controller without delay.

**7. Final provisions**  
7.1. For anything not expressly provided in this appointment, reference is made to general provisions in force regarding personal data protection.   
7.2. This appointment will be governed by Italian law. All disputes that may arise in relation to the content of this appointment deed - including those concerning its validity, effectiveness and interpretation - will be subject to the exclusive jurisdiction of the Court of Brescia.  
7.3. It is understood that no compensation or remuneration for any reason is due to the Processor by virtue of this appointment. 

***

The Data Processor, having taken note of the above, declares to accept the appointment, confirming direct and thorough knowledge of obligations assumed in relation to data protection legislation.`,
    },
  },
  Groups: {
    weeks_duration: "Duration in weeks",
    activate_training_plan: "Active training plan",
    activate_training_plan_success: "Training plan successfully activated",
    deactivate_training_plan: "Deactivate training plan",
    deactivate_training_plan_success: "Training plan successfully deactivated",
    send_notification: "Send notification",
    active_plan: "Active plan",
    inactive_plan: "Inactive plan",
    activate_plan_to_notify: "Activate the plan to send notifications",
    notification_sent: "Notified",
    notify_training_plan: "Notify training plan",
    notify_training_plan_success:
      "Training plan notification sent successfully",
    create_training_plan: "Create training plan",
    assigned_training_plans: "Assigned training plans",
    generate_code_title: "Are you sure you want to regenerate the invite code?",
    generate_code_subtitle: "The previous code will no longer be valid",
    generate_new_code: "Generate new code",
    participants: "Participants",
    add_assignment: "Add Assignment",
    remove_assignment: "Remove Assignment",
    edit_assignment: "Edit Assignment",
    add_assignment_success: "Assignment created successfully",
    remove_assignment_success: "Assignment removed successfully",
    edit_assignment_success: "Assignment modified successfully",
    label_empty_assigned_video_list: "No videos assigned",
    label_empty_playlist_list: "No playlists assigned",
    no_expiration: "No expiration",
    expired: "Expired",
    remove_assign_label:
      "Do you want to remove the assignment from this group?",
    remove_user_from_group:
      "Do you want to remove the customer from the group?",
    missing_days: "Expires in {{count}} days",
    active_from: "Active from",
    weeks: "{{ count }} weeks",
    months: "{{ count }} months",
    duration: "Duration",
    choose_customer: "Choose customer",
    invite_customers: "Invite Customers",
    invite_button: "Invite",
    add_customers: "Add Members",
    add_button: "Add",
    no_customers_to_add: "No customers to add",
    group_members: "Group members",
    add_member_success: "Member added successfully",
    remove_member_success: "Member removed successfully",
    delete_groups: "Delete groups",
    delete_groups_success: "Groups deleted successfully",
    error_groups: "Groups Error",
    error_groups_settings: "Group Settings Error",
    error_groups_subtitle: "Groups error",
    error_group_subtitle: "Unable to load group data",
    error_group_members_subtitle: "Group members list not loaded",
    error_group_manage_members_subtitle: "Add/remove member failed",
    error_create_group: "New group not created",
    error_edit_group: "Group not modified",
    error_delete_group: "Group not deleted",
    error_delete_groups: "Groups not deleted",
    delete_groups_title: "Do you want to delete these groups?",
    delete_group_title: "Do you want to delete this group?",
    delete_groups_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> these groups from the list.",
    delete_group_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> this group from the list.",
    total_count: "customers",
    active_count: "active",
    edit: "Edit",
    video_list: "Assigned videos list",
    playlists_list: "Assigned playlists list",
    training_deadline: "Training deadline",
    list: "Groups list",
    add_group: "Add group",
    label_selected: "selected",
    copy_email: "Copy email",
    delete_training_plan_title: "Do you want to delete this training plan?",
    delete_training_plan_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> the following training plan from the list.",
    select_all_button_one: `Select existing group`,
    select_all_button_other: `Select all {{count}} existing groups`,
    select_all_one: `You selected {{count}} group.`,
    select_all_other: `You selected {{count}} groups.`,
    list_customer_one: `{{count}} customer`,
    list_customer_other: `{{count}} customers`,
    select_all_total: `All {{count}} groups have been selected`,
    cancel_all: `Cancel selection`,
    group_name: "Group name",
    generate: "Generate",
    copy: "Copy",
    invite_code: "Invite code",
    invite_description:
      "Share this invite code with your new customers to connect them to your REVOO account. With this code, customers will see all attached materials (training plans, videos, playlists) after completing registration.",
    delete: "Delete",
    new_group: "New group",
    edit_group: "Edit group",
    photo: "Photo",
    name: "Name",
    create_group: "Create group",
    create_group_success: "Group created successfully",
    edit_group_success: "Group modified successfully",
    warning_emails: "Group emails",
    warning_emails_subtitle: "There are no emails associated with these groups",
    tabs: {
      members: "Members",
      training_plans: "Training plans",
      nutrition_plans: "Nutrition",
      media: "Media",
      settings: "Settings",
      mobile_section_caption: "Section",
    },
    settings: {
      title: "Group settings",
      success: "Group settings saved successfully",
      assign_all_clients: "Assign all your customers to this group",
      enable_chat_for_new_members: "Enable Chat for new group members",
      automate_client_removal: "Automate customer removal from group",
      save_automations: "Save automations",
      after: "After",
      from_their_entrance: "from their entry",
      rule_interval: {
        day: "Days",
        week: "Weeks",
        month: "Months",
        year: "Years",
      },
      in_date: "On date",
      alert: {
        activate_title:
          "Are you sure you want to assign all your current and future customers to this group? (Any removal automations from the group will be removed)",
        deactivate_title:
          "All your customers will be removed from this group. Are you sure you want to proceed?",
      },
    },
  },
  InviteCustomer: {
    title: "Invite new customers",
    description:
      "Share this invite code with your new customer to connect them to your REVOO account.",
    code: "Invite code",
    changeCode: "Want to change your referral code?",
    changeCodeDescription:
      "Generate a new invite code and the previous one will be disabled",
    changeCodeButton: "Generate new",
    copied: "Copied",
    copy: "Copy",
  },
  Login: {
    title: `Sign in to ${appName}`,
    title_mobile: "Sign in to REVOO PT",
    subtitle_mobile: "The app for personal trainers",
    email: "Your email*",
    password: "Password*",
    login: "Sign in",
    error: "Credentials are incorrect",
    error_not_pt: "Unable to sign in",
    error_not_pt_subtitle:
      "Use your credentials to access the training app on your phone.",
    register: "Sign up",
    dont_have_an_account: "Don't have an account?",
  },
  Migration: {
    success: "Migration completed successfully!",
    failed: "Migration failed.",
    already_migrated: "You have already migrated your account.",
    error_migration: "Migration Error",
    error_migration_subtitle: "Migration not completed",
    migration_completed: "Migration Completed",
    migration_completed_success: "Migration completed successfully",
    invalid_token: "Invalid token.",
  },
  Checkout: {
    back_to_app: "Click here to return to the app",
    purchase_error: "An error occurred during purchase",
  },
  Nutrition: {
    add_nutrition_plan: "Add nutrition plan",
    create_nutrition_plan: "Create nutrition plan",
    foods: "Foods",
    addFood: "Add food",
    tabs: {
      plans: "Nutrition plans",
      assigned_plans: "Assigned plans",
    },
    table: {
      columns: {
        name: "Nutrition plan",
        energy: "Energy",
        weekly_average: "Weekly average",
        proteins: "Proteins",
        carbohydrates: "Carbohydrates",
        fats: "Fats",
        days: "Days",
      },
      filters: {
        all: "All",
        assigned: "Personal",
        base_library: "Base Library",
      },
    },
    foodsTable: {
      columns: {
        name: "Name",
        energy: "Energy",
        proteins: "Proteins",
        carbohydrates: "Carbohydrates",
        fats: "Fats",
      },
    },
    foodsDeleteModal: {
      title_one: "Do you want to delete the selected food?",
      title_other: "Do you want to delete the selected foods?",
      subtitle_one:
        "By proceeding you will <strong>permanently delete</strong><br /> this item from the list.",
      subtitle_other:
        "By proceeding you will <strong>permanently delete</strong><br /> the selected items from the list.",
    },
    assign_plan: "Assign Plan",
    plansDeleteModal: {
      title_one: "Do you want to delete the selected plan?",
      title_other: "Do you want to delete the selected plans?",
      subtitle_one:
        "By proceeding you will <strong>permanently delete</strong><br /> this plan from the list.",
      subtitle_other:
        "By proceeding you will <strong>permanently delete</strong><br /> the selected plans from the list.",
    },
  },
  Menu: {
    nutrition: "NutritionPlans",
    settings: "Settings",
    dashboard: "Dashboard",
    customers: "Customers",
    groups: "Groups",
    workouts: "Workouts",
    video: "Video",
    meetings: "Meetings",
    form: "Form",
    calendar: "Calendar",
    activities: "Activities",
    chat: "Chat",
    vods: "Video On Demand",
    notifications: "Notifications",
    products: "Products",
    team: "Team",
    surveys: "Surveys",
  },
  Models: {
    name: "Template name",
    cards: "Cards",
    duration: "Duration",
    duplicate: "Duplicate template",
    level: "Level",
    levels: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      elementary: "Elementary",
    },
    deleteModal: {
      title_one: "Do you want to delete the selected template?",
      title_other: "Do you want to delete the selected templates?",
      subtitle_one:
        "By proceeding you will <strong>delete</strong> the template from the list.",
      subtitle_other:
        "By proceeding you will <strong>delete</strong> the selected templates.",
    },
    forms: {
      assignTitle: "Assign template",
      createTitle: "Create template",
      editTitle: "Edit template",
      editPlans: "Edit plan",
      customers: "Customer",
      groups: "Group",
      name: "Template",
      image: "Cover photo",
      date_of_start: "Start date",
      weeks_duration: "Duration in weeks",
      level: "Level",
      simplifiedVisualization: "Simplified view",
      note: "Notes",
      assign: "Assign",
    },
  },
  Notifications: {
    list: "Notifications list",
    add_notification: "Add notification",
    success_notification_subtitle: "New notification created successfully",
    edit_notification: "Edit notification",
    edit_notification_success: "Notification modified successfully",
    clone_notification: "Duplicate notification",
    success_clone_notification: "Notification duplicated successfully",
    delete_notification: "Delete notification",
    delete_notification_confirm:
      "Are you sure you want to delete notification {{name}}?",
    delete_notification_success: "Notification deleted successfully",
    error_notification: "Notification Error",
    error_notification_subtitle: "Notification not loaded",
    error_notifications: "Notifications Error",
    error_notifications_subtitle: "Notifications list not loaded",
    error_create_notification: "New notification not created",
    error_edit_notification: "Notification not modified",
    error_delete_notification: "Notification not deleted",
    error_clone_notification: "Notification not duplicated",
    error_send_notification: "Notification not sent",
    success_send_notification: "Notification sent successfully",
    error_notification_label: "Notification operation failed",
    form_creation_title: "Create notification - Step {{index}} of {{total}}",
    form_creation_title_simple: "Create Notification",
    form_clone_title: "Clone notification - Step {{index}} of {{total}}",
    form_edit_title: "Edit notification - Step {{index}} of {{total}}",
    alert_confirm_button:
      "By proceeding the notification will be sent again. Are you sure you want to proceed?",
    send_notification: "Send notification",
    send_notification_confirm:
      "Are you sure you want to send this notification?",
    send_notification_success: "Notification sent successfully",
    notification_name: "Notification name",
    notification_text: "Notification text",
    notification_type: "Notification type",
    notification_type_option: {
      push: "Push notification",
      email: "Email",
    },
    notification_target: "Target",
    notification_target_option: {
      all: "All customers",
      group: "Group",
      customer: "Customer",
    },
    notification_group: "Group",
    notification_customer: "Customer",
    notification_date: "Date",
    notification_time: "Time",
    notification_status: "Status",
    notification_status_option: {
      draft: "Draft",
      scheduled: "Scheduled",
      sent: "Sent",
    },
    headers: {
      notification_name: "Title",
      target_type: "Recipients",
      sent_at: "Sent date",
      status: "Status",
      actions: "Actions",
    },
    actions: {
      edit: "Edit",
      clone: "Clone",
      delete: "Delete",
    },
    periodicity_types: {
      instant: "Immediate send",
      scheduled: "Scheduled",
      recurring: "Recurring",
    },
    target_types: {
      all: "All customers",
      customers: "Selected customers",
      groups: "Selected groups",
    },
    frequency_types: {
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
    },
    statuses: {
      pending: "Pending",
      scheduled: "Scheduled",
      sending: "Sending",
      canceled: "Canceled",
      sent: "Sent",
      completed: "Sent",
    },
  },
  Products: {
    label_empty_table: "No transactions available",
    delete: {
      title: "Do you want to delete <br />the selected product?",
      description:
        "By proceeding you will <strong>permanently lose</strong> it",
    },
    form: {
      product_includes: "Product includes: ",
      name: "Product Name",
      short_description: "Short description",
      description: "Description",
      payment_type: "Payment type",
      price: "Final price",
      at_groups: "Assign to groups",
      original_price: "Original price",
      thank_you_message: "Thank you message",
      url_after_purchase: "Post-purchase link",
      payment_type_option: {
        subscription: "Subscription",
        one_time: "One-time purchase",
      },
      price_option: "Every",
      price_options: {
        month: "Month",
        six_weeks: "Six weeks",
        three_months: "Three months",
        six_months: "Six months",
        year: "Year",
      },
      tooltip:
        'If you decide to offer the product at a discounted price, you can enter its original price here; it will be shown "crossed out" in the app to increase conversions. Note: this is not the final selling price!',
    },
    no_operations:
      "You cannot perform operations while a product is under review.",
    table: {
      column: {
        date: "Date",
        customer: "Customer",
        description: "Description",
        amount: "Amount",
        product: "Product",
      },
    },
    error: {
      get_transactions_title: "Transactions Error",
      get_transactions_subtitle: "Transactions not loaded",
      get_product_title: "Product Error",
      get_product_subtitle: "Product not loaded",
      create_product_title: "Product Error",
      create_product_subtitle: "Product not created",
      update_product_title: "Product Error",
      update_product_subtitle: "Product not updated",
      delete_product_title: "Product Error",
      delete_product_subtitle: "Product not deleted",
      notify_product_title: "Product Error",
      notify_product_subtitle: "Product not notified",
      export_transactions_title: "Transaction export error",
      export_transactions_subtitle: "Transactions not exported",
      export_transactions_loading: "Export in progress",
      fetch_transactions_title: "Transaction update error",
      fetch_transactions_subtitle: "Transactions not updated",
    },
    success: {
      create_product_title: "Product created",
      create_product_subtitle: "Product created successfully",
      update_product_title: "Product updated",
      update_product_subtitle: "Product updated successfully",
      delete_product_title: "Product deleted",
      delete_product_subtitle: "Product deleted successfully",
      notify_product_title: "Product notified",
      notify_product_subtitle: "Product notified successfully",
      export_transactions_title: "Transactions exported",
      export_transactions_subtitle: "Transactions exported successfully",
      fetch_transactions_title: "Transactions updated",
      fetch_transactions_subtitle: "Transactions updated successfully",
    },
    tabs: {
      products: "Products",
      transactions: "Transactions",
    },
    buttons: {
      add_product: "Add product",
    },
    edit_product: "Edit product",
    new_product: "New product",
    no_data: "No products available",
    rank: "Rank",
    product: "Product",
    price: "Price",
    status: "Status",
    status_enum: {
      under_review: "Under review",
      approved: "Approved",
      failed: "Failed",
    },
    revoo_pay: {
      no_account: "No account",
      title: "Connect your REVOO account to Stripe",
      connect: "Connect",
      disabled: {
        title: "Sell your training programs simply and automatically.",
        description_1:
          "With REVOO Pay your clients can purchase your programs (workout plans and/or video on-demand) directly from the app.",
        description_2:
          "You create the products from the platform and REVOO takes care of everything else: payments, confirmations and immediate activation of the programs.",
        discover:
          "👉 Discover all the features in the complete document - <button1><text>click here</text></button1>.",
        app_required: "To activate REVOO Pay, a Custom App is required.",
        request_revoo_pay: "Request REVOO Pay",
        request_custom_app: "Request custom app",
      },
    },
  },
  Profile: {
    settings: "Profile settings",
    guide: "Guide",
    webinar_request: "Request Webinar",
    products: "Products",
    guides_and_tutorials: "Guides & Tutorials",
    logout: "Sign out",
  },
  RecoverPassword: {
    recover_password: "Recover password",
    insert_email:
      "Enter the email you registered with to recover your password.",
    email_sent: "We have sent you an email to recover your password.",
    back_to_login: "Back to login",
    reset_password: "Reset password",
    reset_password_subtitle: "Password successfully set.",
  },
  Services: {
    button_label: "Services for you",
    title: "REVOO Services",
    partner_prozis: "Become a Prozis partner",
    invite_friend: "Bring a friend",
    site_web: "Create your website",
    create_app: "Create your app",
  },
  Settings: {
    billing_upgrade_now: "Upgrade now",
    billing_message_title: "<strong>⚠️ Update your payment details</strong>",
    billing_message:
      "We are switching to a new, safer and faster payment system. To continue using the platform without interruption, we ask you to update your <strong>payment</strong> and <strong>billing</strong> details <strong>now</strong>.<br><br>" +
      "🔒 The operation takes a few minutes and is completely safe.<br>",
    error: {
      personal_informations: {
        update_settings_title: "Settings update error",
        update_settings_subtitle: "Settings not updated",
      },
      password: {
        update_settings_title: "Settings update error",
        update_settings_subtitle: "Settings not updated",
      },
      get_settings_title: "Settings error",
      get_settings_subtitle: "Settings not loaded",
      update_settings_title: "Settings update error",
      update_settings_subtitle: "Settings not updated",
    },
    success: {
      update_subscription_title: "Subscription updated",
      update_subscription_subtitle: "Subscription successfully updated",
      personal_informations: {
        update_settings_title: "Settings updated",
        update_settings_subtitle: "Settings successfully updated",
      },
      password: {
        update_settings_title: "Settings updated",
        update_settings_subtitle: "Settings successfully updated",
      },
      update_settings_title: "Settings updated",
      update_settings_subtitle: "Settings successfully updated",
    },
    billing: {
      support_title:
        "Can't see your invoices? Don't worry, we'll send them to you! 😉",
      support_subtitle:
        "Invoices are automatically sent to your email address.<br />For any questions, chat with us or write to <strong>invoices@revoo-app.com</strong>",
      subscription: {
        error: {
          trial_ended: "The trial period has ended.",
        },
        loading: "Loading...",
        loading_portal: "Loading customer portal...",
        title: "Your subscription",
        detail_plan: "Plan details",
        update_payment_method: "Update payment method",
        status: {
          active: "Active",
          trialing: "Trial",
          unpaid: "Unpaid",
          past_due: "Past due",
          no_subscription: "Cancelled",
          canceled: "Cancelled",
        },
        price_interval: {
          month: "Per month",
          year: "Per year",
        },
        active_customers: "Active customers",
        alert: {
          title: "Warning!",
          subtitle:
            "You have exceeded the limit allowed by your subscription, to continue using REVOO please upgrade your plan.",
          invite_title:
            "You have exceeded the invite limit allowed by your subscription.",
        },
        messages: {
          trial_ends_at: "The trial period ends in {{days}} days.",
          trial_ended:
            "The trial period has ended! To continue, update your data.",
          trial_ended_choose_plan:
            "The trial period has ended! Choose a plan to continue.",
          trial_ends_today:
            "The trial period ends today. Choose a plan to continue.",
          no_subscription:
            "You do not have an active subscription. Click on Subscribe to continue.",
          trial_ends_new_plan_starts_at:
            "You are still using the free trial period. The new plan will start on {{ date }}.",
          trial_warning:
            "If at the end of the trial period there are more active Clients or Video On Demand than allowed by the plan you have chosen, you will be asked to upgrade to continue using REVOO.",
          plan_renews_at: "The plan automatically renews on {{ date }}.",
          plan_renews_at_downgrade:
            "This plan will end on {{ date }} and will be replaced by the {{ plan }} plan.",
          payment_problem:
            "Payment problem, click here to update your card details.",
          browser_problem:
            "Problem with payment, go to the site <button1><text>train.revoo-app.com</text></button1> to update your card details.",
          click_on_subscribe:
            "Click on Subscribe to restart your subscription.",
          plan_will_not_renew:
            "Your plan will be canceled as requested, but will remain available until the end of the free trial on {{ date }}.",
          plan_will_not_renew_until:
            "Your plan will be canceled as requested, but will remain available until {{ date }}.",
          plan_will_not_renew_subtitle:
            "If you change your mind you can <button1><text>renew it</text></button1> or <button2><text>choose a new plan</text></button2>.",
          plan_will_be_canceled_at:
            "The plan will be canceled on {{ date }}. If you want to cancel the plan cancellation <button1><text> click here</text></button1>.",
          back_to_old:
            "Do you want to use the previous version of REVOO? <button1><text>Click here</text></button1>.",
          plan_canceled: "The plan has been canceled.",
          plan_canceled_at: "The plan was canceled on {{ date }}.",
          payment_error:
            "Payment failed: check that you have sufficient funds or <button1><text>click here</text></button1> to update your payment method.",
          paddle_migration_action_required:
            "Payment system update.<br>" +
            "We ask you to update your data: the operation is simple and will not incur any charges.",
        },
        buttons: {
          more_info: "More information",
          subscribe: "Subscribe",
          payment_data: "Update payment",
          change_plan: "Change plan",
          update_payment_data: "Update payment data",
        },
      },
      billing_details: {
        no_data: "No data entered",
        title: "Billing details",
        type: {
          company: "Company",
          person: "Individual",
        },
        vat_number: "VAT No. {{value}}",
        tax_code: "Tax Code {{value}}",
        form: {
          title: "Edit billing details",
          type: "Type",
          vat_number: "VAT Number",
          tax_code: "Tax Code",
          address_street: "Address",
          address_postal_code: "Postal Code",
          address_city: "City",
          address_province: "Province",
          country: "Country",
          name: "Full name or company name",
          first_name: "First Name",
          last_name: "Last Name",
          pec: "PEC",
          ei_code: "Unique Code",
          address_street_placeholder: "Enter full address...",
        },
      },
      payment_method: {
        title: "Payment method",
        name: "Account holder name",
        no_data: "No payment method entered",
      },
      change_plan: {
        title: "Subscription plans",
        filters: {
          all: "All",
          up_to_50: "Up to 50 customers",
          up_to_300: "Up to 300 customers",
          unlimited: "Unlimited",
        },
        switch: {
          monthly: "Monthly",
          yearly: "Yearly",
        },
        subtitle: "Choose a new monthly or yearly plan.",
        choose_this_plan: "Choose this plan",
        current_plan: "Current plan",
        previous_plan: "Previous plan",
        most_popular: "Most popular",
        at_month: "per month",
        at_year: "per year",
        start_your_path: "Start your REVOO journey",
        excluded_feature:
          "REVOO pay and app customization <br><strong>are excluded</strong>",
        features: {
          up_to_value_customers: "Up to {{ customers }} customers",
          up_to_value_vods: "{{ vods }} video on demand",
          unlimited_customers: "Unlimited customers",
          unlimited_vods: "Unlimited videos",
          customers_groups: "Customer groups",
          automations: "Automations",
          vods: "Video on demand",
          chat: "Chat",
        },
        contact_us: "Contact us",
        change_plan: "Change plan",
        confirm_and_pay: "Confirm and proceed to payment",
        change_plan_confirm_subtitle:
          "Check your details and complete your subscription",
        change_plan_migration:
          "Check your data and update your subscription. Aggiornando i dati non verrà effettuato nessun addebito.",
        new_plan_selected: "New plan selected",
        automatic_renew_at: "The plan automatically renews on {{ date }}",
        upgrade_message: "Today's charge will be {{ amount }} {{ currency }}",
        downgrade_message:
          "The new plan will activate immediately. You will not be charged now.",
        edit_payment_method: "Edit payment details",
        contact_support:
          "Currently, this operation cannot be performed. Contact support to make changes to the plan.",
      },
      next_payment: {
        included_vat: "VAT included",
        estimate_next_payment: "Estimated next charge",
        description: "Description",
        quantity: "Quantity",
        amount: "Amount",
        total: "Total",
        residual_credit_applied: "Residual credit applied",
        amount_due: "Amount due",
        tooltip:
          "The indicated value includes VAT at 22% if applicable and will be explicitly stated on the invoice.",
      },
    },
    "legal-&-compliance": {
      terms_and_conditions: "Terms and conditions",
      privacy_policy: "Privacy policy",
      appointment_for_data_processing: "Appointment for data processing",
    },
    profile: {
      coaching: "Coaching",
      social: "Social",
      contact_data: "Contact information",
      business_nickname: "Business Nickname",
      image: "Choose your profile photo",
      bio: "Bio",
      email: "Email",
      phone: "Phone",
      show_phone_number: "Show phone number in customer app",
      instagram: "Instagram",
      facebook: "Facebook",
      online: "Online coaching",
      live: "In-person coaching",
    },
    preferences: {
      chat: "Chat",
      active_chat: "Enable chat for new customers",
      workouts: "Workouts",
      show_future_workouts: "Show clients training plans with a future date",
      language: "Language",
      select_language: "Select language",
      languages: {
        it: "🇮🇹 Italian",
        en: "🇬🇧 English",
      },
    },
    personal_informations: {
      personal_data: "Personal data",
      name: "First name",
      surname: "Last name",
      date_of_birth: "Date of birth",
      gender: "Gender",
      country: "Country",
      city: "City",
    },
    password: {
      edit_your_password: "Edit your password",
      new_password: "New password",
      repeat_new_password: "Repeat new password",
      actual_password: "Current password",
    },
    delete_account: {
      delete_account_title: "Delete account",
      delete_account_subtitle:
        "<b>Warning</b>: before deleting your account you must cancel your active subscription.<br />" +
        "<b>As long as the subscription is active, the account deletion cannot be completed.</b><br />" +
        'If you have an active subscription, <billingLink>click here</billingLink>, then select "<b>Plan details</b>" and proceed to cancel the subscription.<br />' +
        "If you are still within the 20-day trial period, you can request account deletion directly without any additional steps.<br />" +
        "<b>Note</b>: the deletion is confirmed within approximately 7 business days.",
    },
    notifications: {
      title: "You can enable or disable individual notifications",
      push_notifications: "Push notifications",
      receive_notifications_when_pt: "Receive notifications when PT",
      receive_notifications_when_customer:
        "Receive notifications when customer",
      crud_on_calendar: "Adds, modifies, deletes calendar event",
      add_anamnesis: "Adds history",
      add_progress_photo: "Adds progress photos",
      add_composition: "Adds body composition",
      add_circumference: "Adds circumference",
      is_not_active: "Is not active",
      workout_plan_expiration: "Workout plan expiring",
      complete_workout: "Completes workout",
      complete_workout_with_feedback: "Completes workout with feedback",
      buy_a_product: "Buys a product",
    },
    card: {
      profile: {
        title: "Profile",
        description:
          "Manage your profile and information to be contacted by your clients",
      },
      "personal-informations": {
        title: "Personal Information",
        description: "Set your personal data",
      },
      password: {
        title: "Password",
        description: "Update your password and protect your account",
      },
      preferences: {
        title: "Preferences",
        description: "Set the language and chat with your clients",
      },
      notifications: {
        title: "Notifications",
        description: "Set your notification preferences",
      },
      billing: {
        title: "Billing",
        description: "Check payment methods, invoices, and upcoming renewals",
        next_payment: {
          title: "Next charge",
        },
      },
      referral: {
        title: "Referral Code",
        description: "View your remaining credit and share your code",
      },
      "legal-&-compliance": {
        title: "Legal & Compliance",
        description:
          "View terms and conditions, privacy policy, and data processing appointment",
      },
      "delete-account": {
        title: "Delete Account",
        description: "Request account deletion",
        message:
          "To proceed, please enter the exact name of the resource <strong>{{name}}</strong> to confirm. This action cannot be undone.",
        confirmation_message:
          "Your deletion request has been recorded. Your account will be deleted within 15 days.",
        modal: {
          subtitle:
            "This account deletion is in progress. Do you want to cancel the procedure?",
          confirm_button: "Cancel deletion",
        },
      },
    },
  },
  Signup: {
    title: `Sign up for ${appName}`,
    already_have_account: "Already have an account?",
    dont_want_to_register: "Don't want to register?",
    login: "Sign in",
    register: "Sign up",
    next: "Next",
    back: "Back",
    insert_your_personal_data: "Enter your personal data",
    insert_your_contact_data: "Enter your contact information",
    set_your_profile: "Set up your profile",
    no_payment_method: "No payment method required",
    completed: "Registration completed!",
    start: "Let's start!",
    form: {
      email: "Your email",
      password: "Password",
      referral_code: "Referral code (optional)",
      gdpr: "I accept the Privacy Policy",
      terms: "I accept the Terms and Conditions of use",
      marketing:
        "I consent to the processing of my personal data to receive offers and promotions from REVOO via email",
      name: "First name",
      surname: "Last name",
      birth_date: "Date of birth",
      gender: "Gender",
      country: "Country",
      city: "City",
      locality: "Location",
      phone_number: "Phone",
      business_nickname: "Business Nickname",
      image: "Choose your profile photo",
    },
    error: {
      title: "Registration Error",
      subtitle: "Registration failed",
    },
  },
  Statistics: {
    activityState: {
      title: "Your activity status",
      customers: "Customers",
      groups: "Groups",
      workouts: "Workouts completed yesterday",
      videoViews: "Videos viewed",
    },
    activeCustomers: {
      title: "Active customers",
      activeCustomers: "Active customers",
      columns: {
        workouts: "Workouts completed",
        customers: "Customers",
        executedAt: "Executed on",
      },
      viewAll: "View all",
    },
    workouts: {
      title: "Workouts",
      filter: "Filter by",
      checkbox: "Show only workouts with feedback",
      columns: {
        customers: "Customers",
        feedback: "Feedback",
        executedAt: "Executed on",
      },
      viewAll: "View all",
    },
    mostViewedVideos: {
      title: "Most viewed videos",
      views: "Views",
      viewAll: "View all",
    },
  },
  Surveys: {
    banner:
      "The update with custom surveys is being released on your custom app. Please check that all contracts are updated on your Apple Developer Account",
    error_surveys: "Surveys Error",
    error_surveys_create:
      "A Form with same internal name already exists. Please choose a different name.",
    add_survey: "Add survey",
    compile_survey: "Complete survey",
    tabs: {
      models: "Templates",
    },
    submissions_count: "Number of submissions",
    submissions: "Submissions",
    model_name: "Survey template name",
    create_survey: "Create survey",
    edit_survey: "Edit survey",
    assign_survey: "Assign survey",
    already_assigned: "Already assigned",
    selected_label: "Selected: {{count}}",
    assigned_label: "Assigned: {{count}}",
    delete_survey: "Delete survey",
    survey: "Survey",
    created_by: "Created by",
    filled_by: "Completed by",
    submission_date: "Submission date",
    submissions_list: "Submissions list",
    see_results: "See results",
    complete: "Complete",
    delete_survey_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> this survey from the list.",
    delete_submission: "Delete submission",
    delete_submission_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> this submission from the list.",
    label_selected: "Selected",
    unassign_survey: "Remove survey",
    unassign_survey_subtitle:
      "By proceeding you will <strong>permanently remove</strong> the survey assignment for this customer.",
    assign_survey_confirm: "Confirm survey assignment",
    assign_survey_confirm_message:
      "Are you sure you want to assign this survey?",
    assigned_to_customers: "Assigned to <strong>{{count}}</strong> customer",
    assigned_to_customers_plural:
      "Assigned to <strong>{{count}}</strong> customers",
    assigned_to_groups: "Assigned to <strong>{{count}}</strong> group",
    assigned_to_groups_plural: "Assigned to <strong>{{count}}</strong> groups",
    customer: "Customer",
    group: "Group",
    members: "Members",
    next: "Next",
    assign: "Assign",
    search: "Search",
    selected: "Selected",
    no_results: "No results found",
    loading: "Loading...",
    confirm_assignment: "Confirm assignment",
    cancel: "Cancel",
    close: "Close",
    back_to_list: "Back to list",
    survey_assigned_success: "Survey assigned successfully",
    survey_assigned_error: "Error assigning survey",
    survey_unassigned_success: "Survey removed successfully",
    survey_unassigned_error: "Error removing survey",
    survey_deleted_success: "Survey deleted successfully",
    survey_deleted_error: "Error deleting survey",
    submission_deleted_success: "Submission deleted successfully",
    submission_deleted_error: "Error deleting submission",
    edit_submission: "Edit submission",
    view_submission: "View submission",
    no_submissions: "No submissions present",
    filter_submissions: "Filter submissions",
    sort_by: "Sort by",
    ascending: "Ascending",
    descending: "Descending",
    export_submissions: "Export submissions",
    import_submissions: "Import submissions",
    submission_details: "Submission details",
    submission_date_range: "Submission date range",
    from_date: "From",
    to_date: "To",
    apply_filters: "Apply filters",
    clear_filters: "Clear filters",
    no_filters_applied: "No filters applied",
    delete_submission_confirm:
      "Are you sure you want to delete this submission?",
    assign_survey_to_customers: "Assign survey to customers",
    assign_survey_to_groups: "Assign survey to groups",
    survey_assigned_successfully: "Survey assigned successfully",
    survey_assignment_error: "Error assigning survey",
    no_customers_selected: "No customers selected",
    no_groups_selected: "No groups selected",
    select_customers_or_groups:
      "Select customers or groups to assign the survey",
    confirm_survey_assignment: "Confirm survey assignment",
    survey_details: "Survey details",
    assigned_to: "Assigned to",
    assignment_summary: "Assignment summary",
  },
  Tags: {
    error_tags: "Tags Error",
    error_tags_subtitle: "Tags list not loaded",
  },
  TrainingPlans: {
    title: "Training Plans",
    titleMobile: "Workouts",
    add: "Add plan",
    exerciseLibrary: "Exercise library",
    tagsLibrary: "Exercise Types",
    tabs: {
      models: "Templates",
      assignedPlans: "Assigned plans",
    },
    error: {
      error_groups: "Groups Error",
      error_groups_subtitle: "Groups error",
    },
  },
  Vods: {
    label_empty_video_list: "No videos in this Library",
    label_empty_customers_list: "No customers to assign",
    label_empty_groups_list: "No groups to assign",
    video_in_progress_tooltip_title: "Video processing.",
    video_in_progress_tooltip_text: "Reload the page in a few minutes.",
    error: {
      vod: {
        title: "Video Error",
        subtitle: "Video not loaded",
        create: "Video not created",
        delete: "Video not deleted",
        edit: "Video not modified",
        assign: "Video not assigned",
        resolution: "Video resolution exceeds the allowed limit (2K)",
      },
      vods: {
        title: "Videos Error",
        subtitle: "Video list not loaded",
      },
      playlist: {
        title: "Playlist Error",
        subtitle: "Playlist not loaded",
        create: "Playlist not created",
        delete: "Playlist not deleted",
        edit: "Playlist not modified",
        assign: "Playlist not assigned",
      },
      playlists: {
        title: "Playlists Error",
        subtitle: "Playlist list not loaded",
      },
    },
    error_playlists: "Playlists Error",
    error_playlists_subtitle: "Playlist list not loaded",
    associated_users: "Associated users",
    weeks_duration: "Duration in weeks",
    date_of_start: "Start date",
    assigned_to: "Assigned to",
    members: "Members",
    assign_video: "Assign Video",
    assign_playlist: "Assign Playlist",
    customer: "Customer",
    group: "Group",
    no_playlist_video: "No videos in this Playlist",
    playlist: "Playlist",
    add_video_playlist: "Add video to playlist",
    video: "Video",
    your_playlists: "Your playlists",
    playlist_video: "Playlist videos",
    sort_by_prefix: "Ordering:",
    sort_by_menu_aria: "Choose how videos in this playlist are ordered",
    sort_mode_manual: "Manual",
    sort_mode_date_added_oldest_first: "Date added (oldest first)",
    sort_mode_date_added_newest_first: "Date added (newest first)",
    sort_mode_confirm_to_manual_title: "Switch to custom order?",
    sort_mode_confirm_to_date_asc_title: "Order by date added: oldest first?",
    sort_mode_confirm_to_date_desc_title: "Order by date added: newest first?",
    sort_mode_change_confirm_subtitle:
      "The ordering will be applied to all videos in the playlist. You can change it at any time.",
    sort_mode_switch_aria: "Change how videos in this playlist are ordered",
    sort_mode_switch_info_aria: "More about playlist ordering",
    sort_mode_switch_tooltip:
      "This setting is saved for this playlist. Whenever you change ordering, the video order in the list is updated accordingly.",
    sort_mode_drag_rows: "Drag rows to reorder them.",
    sort_mode_mobile_reorder_hint:
      "Use the arrows at the top right of each row to move videos up or down.",
    sort_mode_move_up_aria: "Move up",
    sort_mode_move_down_aria: "Move down",
    sort_mode_remove_from_playlist_aria: "Remove {{title}} from playlist",
    sort_mode_drag_handle_aria: "Drag to reorder",
    sort_mode_search_clears_drag: "Clear search to drag and reorder videos",
    playlist_vod_date_added_row: "Added on {{date}}",
    add_video: "Add video",
    edit_video: "Edit video",
    info_message:
      "Your videos are private. No other Personal Trainer can see them.",
    format_supported: "Supported format: MP4, MOV, WMV, AVI, FLV.",
    max_size: "Max {{size}}",
    name: "Name",
    playlist_title: "Playlist Title",
    description: "Description",
    category: "Category",
    loading: "Loading",
    loading_alert: "Do not leave this page until completion",
    loading_initializing: "Initializing",
    loading_stop: "Stop",
    loading_success: "Upload complete!",
    thumbnail_image: "Cover Photo",
    options: "Options",
    playlists: "Playlists",
    views: "Views",
    success_delete_video: "Delete video",
    success_edit_video: "Edit video",
    success_delete_video_subtitle: "Video successfully deleted",
    success_assign_video: "Assign video",
    success_assign_video_subtitle: "Video successfully assigned",
    success_assign_playlist: "Assign Playlist",
    success_assign_playlist_subtitle: "Playlist successfully assigned",
    success_edit_video_subtitle: "Video successfully modified",
    success_create_playlist_subtitle: "Playlist successfully created",
    success_add_playlist_video_subtitle: "Video successfully added to Playlist",
    success_delete_playlist_video_subtitle:
      "Video successfully removed from Playlist",
    success_delete_playlist_subtitle: "Playlist successfully deleted",
    success_edit_playlist_subtitle: "Playlist successfully modified",
    delete_video_title: "Do you want to delete this video?",
    delete_video_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> this video from the list.",
    title: "Title",
    video_bookshelf: "Video Library",
    video_bookshelf_short: "Library",
    videos_ordering_shared_with_client_app:
      "Video order is shared with your clients' training app. Any changes you make will be synced to the app in real time.",
    add_playlist: "Create playlist",
    edit_playlist: "Edit playlist",
    delete_playlist: "Delete playlist",
    delete_playlist_title: "Do you want to delete this playlist?",
    delete_playlist_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> this playlist from the list.",
    monthly_views: "Monthly views",
    monthly_views_tooltip_title: "Warning!",
    monthly_views_tooltip_text:
      "This is a premium feature, after {{views}} monthly views the paid plan will be automatically activated. Click for more information.",
  },
  VodsStatistics: {
    title: "Video Views",
    associatedGrup: "{{count}} group",
    associatedGrup_other: "{{count}} groups",
    associatedCustomers: "{{count}} customer",
    associatedCustomers_other: "{{count}} customers",
    views: "{{count}} view",
    views_other: "{{count}} views",
    columns: {
      video: "Video",
      associated: "Associated with",
      views: "Views",
    },
  },
  Attachments: {
    delete_attachment: "Do you want to delete this attachment?",
    delete_attachment_subtitle:
      "By proceeding you will <strong>permanently delete</strong><br /> the selected attachment.",
    success: {
      create_attachment_title: "Create Attachment",
      create_attachment: "Attachment created successfully",
      edit_attachment_title: "Edit Attachment",
      edit_attachment: "Attachment updated successfully",
      delete_attachment_title: "Delete Attachment",
      delete_attachment: "Attachment deleted successfully",
    },
    error: {
      create_attachment_title: "Attachment Creation Error",
      create_attachment: "Error creating attachment",
      edit_attachment_title: "Attachment Update Error",
      edit_attachment: "Error updating attachment",
      delete_attachment_title: "Attachment Deletion Error",
      delete_attachment: "Error deleting attachment",
    },
  },
  WorkoutStatistics: {
    title: "Workout Feedback",
    columns: {
      customer: "Customer",
      feedback: "Feedback",
      last: "Last workout",
    },
  },
  common: {
    copy_emails: {
      success_one: "{{count}} address copied",
      success_other: "{{count}} addresses copied",
      empty_title: "No address copied",
      empty_subtitle: "The selected items have no email address",
      error_title: "Copy failed",
      error_subtitle: "The email addresses could not be copied",
    },
    apiError: {
      validation: "Check the data you entered: {{fields}}.",
      validation_generic: "Some data was not accepted.",
      too_large: "The file is too large to be uploaded.",
      session: "Your session has expired: reload the page and try again.",
      forbidden: "Your subscription does not allow this operation.",
      server: "Server error: please try again in a few minutes.",
      network:
        "The request never reached the server. Check your connection and do not close the window while uploading.",
      generic: "The operation could not be completed.",
      code: "Error code: {{code}} — please report it to support.",
      field: {
        name: "name",
        video: "video",
        image: "cover photo",
        tags: "tags",
        link: "video link",
        note: "notes",
      },
    },
    status: "Status",
    activate: "Activate",
    deactivate: "Deactivate",
    calendar: "Calendar",
    guide: "Guide",
    other: "Other",
    document: "Document",
    name: "Name",
    category: "Category",
    coming_soon:
      "💡 Do you have a brilliant idea or a request? <button1><text>Click here and tell us about it!</text></button1>",
    expand: "Expand",
    reduce: "Reduce",
    print: "Print",
    understood: "Understood",
    download: "Download",
    no_data: "No data available",
    refresh: "Refresh",
    every: "every",
    send_notification: "Send notification",
    view: "View",
    save_as_draft: "Save as draft",
    description: "Description",
    date_of_start: "Start date",
    detail: "Detail",
    change: "Change",
    label_empty_table: "No results found",
    write_us: "Write to us",
    options: "Options",
    export: "Export",
    attachments: "Attachments",
    nutrition: "Nutrition",
    progress_module: "Progress module",
    list: "List",
    load_more: "Load more",
    remove: "Remove",
    back: "Back",
    replace: "Replace",
    assign: "Assign",
    next: "Next",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    duplicate: "Duplicate",
    compare: "Compare",
    manage_associates: "Manage associates",
    assign_playlist: "Assign Playlist",
    add: "Add",
    create: "Create",
    close: "Close",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy - H:mm",
    dateFormatLong: "EEE dd LLL yyyy",
    date: "Date",
    timeFormat: "HH:mm",
    openLink: "Open link",
    selected: "Selected",
    before: "before",
    roles: {},
    error: {
      404: "Page not found",
      age_restriction: "You must be at least 18 years old",
      required: "Required",
      invalidLogin: "Invalid email address",
      email: "Invalid email address",
      max_date_today: "The date must be less than or equal to today",
      min_length: "Minimum length not reached",
      max_length: "Maximum length exceeded",
      max_length_chars: "Maximum {{max}} characters",
      atLeastOne: "You must fill in at least one field",
      fiscal_code: "Invalid tax code",
      valid_url: "Invalid URL",
      phone: "Invalid phone number",
      must_match: "Passwords must match",
      postal_code: "The postal code must be 5 digits",
      pec_or_ei_code_required:
        "At least one field between PEC and Unique Code is required",
      min_time: "The minimum time is 15 minutes from now",
      date_max_1_month:
        "The end date must be at most one month from the start date",
      date_min_1_day:
        "The end date must be at least one day from the start date",
      youtube_not_allowed: "YouTube links are not allowed",
    },
    select_all: "Select all",
    select_placeholder: "Select…",
    male: "Male",
    female: "Female",
    gender_other: "Prefer not to say",
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "LinkedIn",
    at_gym: "At the gym",
    word_of_mouth: "Word of mouth",
    dont_know: "Don't know",
    live: "Live",
    search: "Search",
    remote: "Remote",
    reset: "Reset",
    reset_all: "Reset Filters",
    groups: "Groups",
    filters: "Filters",
    customers: "Customers",
    end: "End",
    notes: "Notes",
    start: "Start",
    label: "Label",
    label_results: "Results",
    show_results: "Show Results",
    live_and_remote: "Live and remote",
    active_chat: "Activate chat for this customer",
    confirm: "Confirm",
    imageAvatar: {
      modalTitle: "Edit image",
      modalTopBodyLabel: "Drag the image to select the area to crop",
      zoomLabel: "Adjust image zoom",
      previewAlt: "Preview",
      insertLabel: "Select a photo or drag",
      insertLabelMobile: "Choose image",
      dropLabel: "Drag the file here...",
      errorLabel: "The selected files are not valid",
      saveLabel: "Save",
      cancelLabel: "Cancel",
    },
    save: "Save",
    save_as_new: "Save as new",
    compositions: {
      weight: "Weight",
      bmr: "BMR",
      body_fat: "Body fat",
      body_temperature: "Body temperature",
      metabolic_age: "Metabolic age",
      bmi: "BMI",
      lean_mass: "Lean mass",
      bone_mass: "Bone mass",
      visceral_fat: "Visceral fat",
      tdee: "TDEE",
      tbw: "TBW",
      steps: "Steps",
      distance: "Distance",
      calories: "Calories",
      "nutrition.carbs.total": "Carbohydrates",
      "nutrition.fat.total": "Fats",
      "nutrition.protein": "Proteins",
    },
    health: {
      steps: "Steps",
      distance: "Distance",
      calories: "Calories",
      "nutrition.carbs.total": "Carbohydrates",
      "nutrition.fat.total": "Fats",
      "nutrition.protein": "Proteins",
    },
    plicometries: {
      protocol: "Protocol",
      age: "Age",
      gender: "Gender",
      chest: "Chest",
      body_fat: "Body fat",
      subscapularis: "Subscapular",
      axillary: "Axillary",
      suprailiac: "Suprailiac",
      abdominal: "Abdominal",
      tricep: "Tricep",
      bicep: "Bicep",
      leg: "Leg",
    },
    measurements: {
      chest: "Chest",
      shoulders: "Shoulders",
      hip: "Hip",
      waist: "Waist",
      bicep: "Biceps",
      calf: "Calves",
      leg: "Leg",
      wrist: "Wrist",
      buttocks: "Buttocks",
    },
    dates: {
      today: "Today",
      yearsAgo_one: "One year ago",
      yearsAgo_other: "{{count}} years ago",
      monthsAgo_one: "One month ago",
      monthsAgo_other: "{{count}} months ago",
      weeksAgo_one: "One week ago",
      weeksAgo_other: "{{count}} weeks ago",
      daysAgo_one: "One day ago",
      daysAgo_other: "{{count}} days ago",
      hoursAgo_one: "One hour ago",
      hoursAgo_other: "{{count}} hours ago",
    },
    duration: {
      today: "No duration",
      yearsAgo_one: "One year",
      yearsAgo_other: "{{count}} years",
      monthsAgo_one: "One month",
      monthsAgo_other: "{{count}} months",
      weeksAgo_one: "One week",
      weeksAgo_other: "{{count}} weeks",
      daysAgo_one: "One day",
      daysAgo_other: "{{count}} days",
      hoursAgo_one: "One hour",
      hoursAgo_other: "{{count}} hours",
    },
    cards_one: "{{count}} card",
    cards_other: "{{count}} cards",
    filterOptions: {
      satisfaction: {
        label: "Rating",
        0: "Not entered",
        1: "🙂 Very good",
        2: "😐 Normal",
        3: "☹️ Bad",
      },
      period: {
        label: "Period",
        lastweek: "This week",
        lastmonth: "Last month",
        last3month: "Last 3 months",
        last6month: "Last 6 months",
        lastyear: "Last year",
      },
    },
    search_customers: "Search customers",
    search_groups: "Search groups",
    no_results_found: "No results found",
    loading: "Loading...",
    deselect_all: "Deselect all",
    show_more: "Show More",
    show_less: "Show Less",
  },
};
